import React, { useEffect, useState } from "react";
import { Link } from "react-router";
import { FaEye, FaTrash, FaTimes } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { openModal } from "../../../redux/features/modalSlice";
import Pagination from "../../../common/Pagination";
import { formatDateTime } from "../../../Utils/formatters";
import {
  getEnquriesList,
  DeleteEnquiry,
  ContactUsChangeStatus,
} from "../../../redux/services/EnquriesService/enquries.Services";

function PendingEnquiryList() {
  const dispatch = useDispatch();
  const { refreshData } = useSelector((state) => state.modal);
  const [showRemarkPopup, setShowRemarkPopup] = useState(false);
  const [selectedRemark, setSelectedRemark] = useState("");
  const [rolesData, setRolesData] = useState([]);
  const [initialLoading, setInitialLoading] = useState(true);
  const [tableLoading, setTableLoading] = useState(false);

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(100);

  const [totalRoles, setTotalRoles] = useState(0);
  const [totalPages, setTotalPages] = useState(1);

  // ✅ Safe extraction of array + pagination meta
  const fetchEnquiryList = async (pageNo = 1, isInitialLoad = false) => {
    try {
      if (isInitialLoad) {
        setInitialLoading(true);
      } else {
        setTableLoading(true);
      }

      const payload = { page: pageNo, per_page: limit, status: "pending" };

      const res = await getEnquriesList(payload);

      // Handle both shapes:
      // 1) { data: [...], current_page, last_page, total }
      // 2) { data: { data: [...], current_page, last_page, total } }
      const inner = res?.data;
      const list = Array.isArray(inner?.data)
        ? inner.data
        : Array.isArray(inner)
          ? inner
          : [];

      const meta = Array.isArray(inner?.data) ? inner : res;

      setRolesData(list);
      setPage(meta?.current_page ?? 1);
      setTotalPages(meta?.last_page ?? 1);
      setTotalRoles(meta?.total ?? 0);
    } catch (err) {
      console.log("fetchEnquiryList error:", err);
      setRolesData([]);
    } finally {
      setInitialLoading(false);
      setTableLoading(false);
    }
  };

  const handleRemarkClick = (remark) => {
    setSelectedRemark(remark || "No Remark");
    setShowRemarkPopup(true);
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages && !tableLoading) {
      setPage(newPage);
      fetchEnquiryList(newPage, false);
    }
  };

  useEffect(() => {
    fetchEnquiryList(1, true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshData, limit]);

  if (initialLoading) {
    return (
      <div className="text-center py-5">
        <div className="spinner-border text-primary"></div>
      </div>
    );
  }

  return (
    <div>
      {/* HEADER */}
      <div className="d-flex align-items-center justify-content-between page-header-breadcrumb">
        <div className="title_member">
          <h4>Pending</h4>
          <nav className="page-breadcrumb">
            <Link to="/">Home</Link>
            <span className="mx-2">/</span>
            <span>Pending</span>
          </nav>
        </div>
      </div>

      {/* Main Content */}
      <div className="main_page">
        {totalPages > 1 && (
          <div className="d-flex justify-content-between align-items-center flex-wrap mb-3">
            <div className="col-12 d-flex justify-content-end">
              <Pagination
                page={page}
                totalPages={totalPages}
                onPageChange={handlePageChange}
              />
            </div>
          </div>
        )}

        <div className="st-wrapper-card text-center">
          <div className="st-table-responsive">
            <table className="table st-custom-table align-middle mb-0" style={{ width: "100%" }}>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Date & Time</th>
                  <th>Name</th>
                  <th>Mobile</th>
                  <th>Email</th>
                  <th>Enquiry From</th>
                  {/* <th>Remark</th> */}
                  <th>Update Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {tableLoading ? (
                  <tr>
                    <td colSpan="9" className="text-center py-5" style={{ width: "100%" }}>
                      <div className="spinner-border text-primary"></div>
                    </td>
                  </tr>
                ) : rolesData.length === 0 ? (
                  <tr>
                    <td colSpan="9" className="text-center py-5">
                      <h5 className="mb-0 text-center">No Pending Enquiries Found</h5>
                    </td>
                  </tr>
                ) : (
                  rolesData.map((item, index) => (
                    <tr key={item.id}>
                      <td>{(page - 1) * limit + index + 1}</td>
                      <td style={{ whiteSpace: "nowrap", fontSize: "13px" }}>
                        {formatDateTime(item.created_at)}
                      </td>
                      <td>{item.name}</td>
                      <td>{item.mobile || item.phone}</td>
                      <td>{item.email}</td>
                      <td>{item.type}</td>
                      {/* <td className="">
                        <div
                          className="remark-cell text-primary"
                          style={{
                            cursor: "pointer",
                            maxWidth: "150px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                          onClick={() => handleRemarkClick(item.remarks)}
                        >
                          {item.remarks || "-"}
                        </div>
                      </td> */}
                      <td>
                        <select
                          className={`form-select form-select-sm kyc-status-select ${item.status === "approved"
                              ? "kyc-approve"
                              : item.status === "rejected"
                                ? "kyc-reject"
                                : "kyc-pending"
                            }`}
                          value={item.status || "pending"}
                          onChange={(e) => {
                            const newStatus = e.target.value;
                            if (newStatus === (item.status || "pending")) return;

                            dispatch(
                              openModal({
                                type: "enduiry-status-remark",
                                title: "Enquiry Status Remark",
                                data: {
                                  id: item.id,
                                  type: item.type,
                                  currentStatus: item.status || "pending",
                                  newStatus: newStatus,
                                  refreshRemarks: () =>
                                    fetchEnquiryList(page),
                                  onSubmit: async (payload) => {
                                    return await ContactUsChangeStatus(
                                      payload
                                    );
                                  },
                                },
                              })
                            );
                          }}
                          style={{
                            width: "140px",
                            height: "36px",
                            fontSize: "13px",
                            fontWeight: 600,
                          }}
                        >
                          <option value="pending">Pending</option>
                          <option value="approved">Approve</option>
                          <option value="rejected">Reject</option>
                        </select>
                      </td>
                      <td>
                        <div className="d-flex align-items-center justify-content-center gap-1">
                          <button
                            className="st-action-btn st-delete-btn"
                            onClick={() =>
                              dispatch(
                                openModal({
                                  type: "view-enquiry",
                                  title: "View Enquiry",
                                  data: item,
                                })
                              )
                            }
                          >
                            <FaEye />
                          </button>

                          {/* Edit (disabled) */}
                          {/* <button
                            className="st-action-btn st-edit-btn"
                            onClick={() =>
                              dispatch(
                                openModal({
                                  type: "edit-enquiry",
                                  title: "Edit Enquiry",
                                  data: {
                                    ...item,
                                    refreshData: fetchEnquiryList,
                                  },
                                })
                              )
                            }
                          >
                            <FaEdit />
                          </button> */}

                          {/* Delete */}
                          <button
                            className="st-action-btn st-edit-btn"
                            onClick={() =>
                              dispatch(
                                openModal({
                                  type: "delete-enquiry",
                                  title: "Delete Enquiry",
                                  data: {
                                    id: item.id,
                                    name: item.name,
                                    type: item.type,
                                    deleteFunction: DeleteEnquiry,
                                    refreshData: fetchEnquiryList,
                                  },
                                })
                              )
                            }
                          >
                            <FaTrash />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>

            {totalPages > 1 && (
              <div className="d-flex justify-content-end mt-3">
                <Pagination
                  page={page}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                />
              </div>
            )}
          </div>
        </div>

        {showRemarkPopup && (
          <div
            className="modal fade show"
            style={{
              display: "block",
              backgroundColor: "rgba(0,0,0,0.5)",
            }}
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Remark Details</h5>

                  <button
                    type="button"
                    className="btn-close text-light"
                    style={{ background: "transparent" }}
                    onClick={() => setShowRemarkPopup(false)}
                  >
                    <FaTimes />
                  </button>
                </div>

                <div className="modal-body">
                  <p style={{ whiteSpace: "pre-wrap" }}>{selectedRemark}</p>
                </div>

                <div className="modal-footer">
                  <button
                    className="btn btn-secondary"
                    onClick={() => setShowRemarkPopup(false)}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default PendingEnquiryList;